import React from 'react';

const ApplicationStatusHistory = ({ applicant }) => {
  console.log('Applicant:', applicant);

  if (!applicant?.application_status_history?.length) {
    return <div>No status history available</div>;
  }

  /**
   * application_status_history:[
    {
    "id": 54,
    "application_id": 38,
    "vacancy_status_id": 2174,
    "changed_by": {
        "id": 1,
        "name": "Greg Admin"
    },
    "changed_at": "2025-03-18 09:54:35",
    "created_at": "2025-03-18T09:54:35.000000Z",
    "updated_at": "2025-03-18T09:54:35.000000Z",
    "deleted_at": null,
    "vacancy_status": {
        "id": 2174,
        "p_order": "2",
        "created_at": "2025-03-14 15:16:22",
        "updated_at": "2025-03-14 15:16:22",
        "deleted_at": null,
        "vacancy_id": 84,
        "status_id": 12,
        "status": {
            "id": 12,
            "name": "Application Form"
        }
    }
    ]
}
   */

  
  return (
    <div>
      <table className="w-full border-collapse text-muted-foreground">
        <thead>
          <tr className="font-semibold text-left border-b-2 ">
            <th className="p-2 ">Status</th>
            <th className="p-2">Changed By</th>
            <th className="p-2">Changed At</th>
          </tr>
        </thead>
        <tbody>
          {applicant.application_status_history.map((history, index) => (
            <tr key={index} className="hover:bg-muted border-b">
              {/* style={{ color: history?.vacancy_status?.status?.bg_color ?? '#000' }} */}
                <td className="p-2">
                    {history?.vacancy_status?.status?.name || 'Unknown Status'}
                </td>
              <td className="p-2">{history?.changed_by?.name || 'Unknown User'}</td>
              <td className="p-2">
                {/* {history?.changed_at ? new Date(history.changed_at).toLocaleDateString() : 'Unknown Date'} */}
                {history?.changed_at ? new Date(history.changed_at).toLocaleDateString() + ' ' + new Date(history.changed_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : 'Unknown Date & Time'}

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ApplicationStatusHistory; 